import React from 'react';
import Button from '../Utils/Button';
import { ChangeUsername, sessionUserLoggedIn } from '../Core/LoginManager'
import Modal from 'react-bootstrap/Modal';
import { minUsernameLength, maxLoggedOutUsernameLength, maxLoggedInUsernameLength } from '../../env';

class EditUsernamePopup extends React.Component
{
  constructor( props )
  {
    super( props );

    let currentUsername = props.value;

    if( !sessionUserLoggedIn )
    {
      // Remove the #XXXX postfix content
      currentUsername = currentUsername.replace( /#\d{4}$/, '' );
    }

    this.state = { value: currentUsername, startingValue: currentUsername };

    this.handleChange = this.handleChange.bind( this );
    this.handleSubmit = this.handleSubmit.bind( this );

    this.changeUsername = props.changeUsername;
  }

  handleChange( event )
  {
    const value = event.target.value;

    let feedback = '';
    if( value.length < minUsernameLength )
    {
      feedback = `Username must be at least ${minUsernameLength} characters.`;
    }
    else if( value.length > maxLoggedInUsernameLength )
    {
      feedback = `Username must be at most ${maxLoggedInUsernameLength} characters.`;
    }
    else if( /[^a-zA-Z0-9]/.test( value ) )
    {
      feedback = 'Username must only contain letters and numbers.';
    }
    else if( value === this.state.startingValue )
    {
      feedback = 'This is your current username.';
    }
    else if( !sessionUserLoggedIn && value.length > maxLoggedOutUsernameLength )
    {
      feedback = `Username can't be longer than ${maxLoggedOutUsernameLength} when not logged in.`;
    }
    this.setState( { value, feedback } );
  }

  async handleSubmit()
  {
    let newUsername = this.state.value;
    let response = await ChangeUsername( newUsername );

    // console.log( "response", response );

    if( response.success )
    {
      this.changeUsername( this.state.value );
    }
    else
    {
      this.setState( { feedback: response.error } );
    }
  }

  render()
  {
    const numUsernameChangesRemaining = this.props.sessionUsernameChangesRemaining;

    return (

      <Modal
        show={ true }
        onHide={ this.props.close }
        centered
        className="modal-popup"
      >
        <Modal.Header>
          <Modal.Title className="modal-popup-title">Change Username</Modal.Title>
        </Modal.Header>

        <Modal.Body className="edit-username-popup-modal-body">

          <div className="edit-username-popup-change-username-text">Change your username to:</div>
          <form onSubmit={ this.handleSubmit }>
            <div style={ { position: 'relative', display: 'inline-block', width: '100%' } }>
              <input
                type="text"
                value={ this.state.value }
                onChange={ this.handleChange }
                className="edit-username-popup-input-field"
                maxLength={ maxLoggedInUsernameLength }
                style={ { paddingRight: '48px', width: '100%' } }
              />
              <span
                style={ {
                  position: 'absolute',
                  right: '12px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  fontSize: '0.95em',
                  color: '#888',
                  pointerEvents: 'none',
                  background: 'white',
                  padding: '0 2px'
                } }
              >
                { `${this.state.value.length}/${maxLoggedInUsernameLength}` }
              </span>
            </div>
          </form>

          <div className="edit-username-popup-feedback-text">{ this.state.feedback }</div>

          <div className="edit-username-popup-remaining-changes">
            You have <span style={ {
              fontWeight: numUsernameChangesRemaining === 1 || numUsernameChangesRemaining === 0 ? 'bold' : 'normal',
              color: numUsernameChangesRemaining === 0 ? 'red' : 'inherit'
            } }>{ numUsernameChangesRemaining } attempt{ numUsernameChangesRemaining > 1 || numUsernameChangesRemaining == 0 ? 's' : '' }</span> left to change your username.
            { numUsernameChangesRemaining <= 0 && !sessionUserLoggedIn ? ( <b> Log in to receive another attempt.</b> ) : <></> }
          </div>
        </Modal.Body>

        <Modal.Footer>

          <Button onClick={ this.props.close } style={ { display: 'block', marginLeft: 'auto', marginRight: 'auto' } } >
            Cancel
          </Button>

          <Button
            onClick={ this.handleSubmit }
            style={ {
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
              opacity: this.state.feedback ? 0.5 : 1,
              pointerEvents: this.state.feedback ? 'none' : 'auto',
              backgroundColor: this.state.feedback ? '#ccc' : undefined
            } }
            disabled={ !!this.state.feedback || numUsernameChangesRemaining <= 0 }
          >
            Confirm
          </Button>

        </Modal.Footer>
      </Modal >
    );
  }
}

export default EditUsernamePopup;
